import { getOfficeConsent } from './GetOfficeConsent';
import { acceptAllOfficeConsents } from './AcceptAllOfficeConsents';
import { getOfficeConsentContent } from './GetOfficeConsentContent';
import { acceptOfficeConsentContent } from './AcceptOfficeConsentContent';

export const ConsentsClient = {
  getOfficeConsent,
  acceptAllOfficeConsents,
  getOfficeConsentContent,
  acceptOfficeConsentContent,
};
